<template>
  <PopUpContents
    ref="popup"
    width="56rem"
    height="48rem"
  >
    <!-- ------------ -->
    <!--  item   -->
    <!-- ------------ -->
    <div class="item-fluid p-3 m-2 bb-clear-dialog-content">
      <!-- ----------------- -->
      <!-- row 1 - title     -->
      <!-- ----------------- -->
      <div class="row h-40">
        <p class="bb-page-title mt-3 mb-2">{{ title }}</p>
      </div>
      <!-- ----------------- -->
      <!-- row 2 - subject   -->
      <!-- ----------------- -->
      <!-- <p class="bb-hdg mt-3 mb-3">{{ subject }}</p> -->
      <!-- ---------------------- -->
      <!--  row 3 - item/buttons  -->
      <!-- ---------------------- -->
      <div class="row mt-3 mb-3">
        <!-- ------- -->
        <!--  item   -->
        <!-- ------- -->
        <div class="col-7 form-group">
          <div class="form-floating">
            <input
              readonly
              class="form-control"
              :value="item.name"
              id="name"
              disabled
            />
            <label
              class="bb-float-label optional"
              for="name"
              >Item Name</label
            >
          </div>
        </div>
        <!-- ---------- -->
        <!--  buttons   -->
        <!-- ---------- -->
        <div class="col-5">
          <div
            class="btn-group special mt-4"
            role="group"
          >
            <!-- ------------ -->
            <!--    cancel    -->
            <!-- ------------ -->
            <button
              v-if="cancelButton"
              type="button"
              @click="_cancel"
              class="btn btn-lg btn-warning"
            >
              {{ cancelButton }}
            </button>
            <!-- ------------ -->
            <!--      OK      -->
            <!-- ------------ -->
            <button
              v-if="okButton"
              type="button"
              @click="_confirm"
              class="btn btn-lg btn-primary"
            >
              {{ okButton }}
            </button>
          </div>
        </div>
      </div>
      <!-- ---------------------- -->
      <!--   row 3 - clear list   -->
      <!-- ---------------------- -->
      <div class="row mt-3 mb-3"></div>
      <div class="row mt-3 mb-3"></div>
      <p class="bb-hdg mt-3 mb-3">{{ message }}</p>
      <div class="row mt-3 mb-3 clear-dialog-list-row">
        <div class="form-group clear-dialog-list-group">
          <div class="form-floating clear-dialog-list-floating">
            <div
              class="form-control bb-linked-values-scroll clearList-dialog-select"
              id="item"
            >
              <div
                v-for="(value, idx) in clearList"
                :key="idx"
                class="bb-linked-values-item clearList-item"
              >
                {{ value }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </PopUpContents>
</template>

<script>
import PopUpContents from './PopUpContents.vue'

export default {
  name: 'ClearDialog',
  components: {
    PopUpContents,
  },
  //=====================================================================
  // data
  //------
  data: () => ({
    title: undefined,
    subject: undefined,
    message: undefined,
    okButton: undefined,
    cancelButton: undefined,
    rejectPromise: undefined,
    resolvePromise: undefined,
    item: {},
    clearList: [],
    adjustments: {},
    forceOpenWhenEmpty: false,
    emptyListEntry: '',
    showTransferUnavailableWarnings: false,
    showRecoveryUnavailableWarnings: false,
  }),
  //=====================================================================
  // methods
  //---------
  methods: {
    //================================================================================
    // generic formatter for ENC-like numeric fields
    //-----------------------------------------------
    formatEnc(value) {
      if (value === null || value === undefined) return ''
      const num = typeof value === 'string' ? parseFloat(value) : value
      if (Number.isNaN(num)) return ''
      return num.toFixed(2)
    },
    normalizeId(value) {
      if (value === null || value === undefined || value === '') return null
      return String(value)
    },
    getLinkedCharacterItemId(entry) {
      if (!entry) {
        return null
      }

      const rawLinkedItem =
        entry.character_item ?? entry.character_item_id ?? entry.item_id ?? null

      if (
        rawLinkedItem === null ||
        rawLinkedItem === undefined ||
        rawLinkedItem === ''
      ) {
        return null
      }

      if (typeof rawLinkedItem === 'object') {
        return this.normalizeId(rawLinkedItem.id)
      }

      return this.normalizeId(rawLinkedItem)
    },
    formatSpellLabel(spell) {
      const label = spell?.display_name || spell?.name || 'Spell'
      const mag =
        spell?.mag !== undefined && spell?.mag !== null
          ? ` (Mag ${spell.mag})`
          : ''

      return `${label}${mag}`
    },
    formatItemSpellPrefix(spell) {
      const spellType = String(spell?.type || '').trim()

      if (spellType === 'Sorcery') {
        return 'Item Spell (Sorcery) & Casting Skill'
      }

      if (spellType !== '') {
        return `Item Spell (${spellType})`
      }

      return 'Item Spell'
    },
    appendReasonEntries(clearList, prefix, reasons) {
      if (!Array.isArray(clearList) || !prefix || !reasons) {
        return
      }

      reasons
        .split('. ')
        .map((entry) => entry.trim().replace(/[.]+$/u, ''))
        .filter((entry) => entry !== '')
        .forEach((entry) => {
          clearList.push(`${prefix}: ${entry}`)
        })
    },
    formatPowerStorageValue(value) {
      const numericValue = Number(value)

      if (!Number.isFinite(numericValue)) {
        return String(value ?? '').trim()
      }

      return Number.isInteger(numericValue)
        ? String(numericValue)
        : String(numericValue)
    },
    //================================================================================
    // show dialog
    //-------------
    show(opts = {}) {
      // passed in parms
      this.title = opts.title
      this.subject = opts.subject
      this.item = opts.item
      this.character = opts.character
      this.adjustments = opts.adjustments
      this.message = opts.message
      this.forceOpenWhenEmpty = opts.forceOpenWhenEmpty === true
      this.emptyListEntry =
        typeof opts.emptyListEntry === 'string'
          ? opts.emptyListEntry.trim()
          : ''
      this.showTransferUnavailableWarnings =
        opts.showTransferUnavailableWarnings === true
      this.showRecoveryUnavailableWarnings =
        opts.showRecoveryUnavailableWarnings === true

      console.log('SHOW item =', this.item)
      console.log('SHOW character =', this.character)
      console.log('SHOW adjs =', this.adjustments)

      if (opts.okButton) {
        this.okButton = opts.okButton
      }
      if (opts.cancelButton) {
        this.cancelButton = opts.cancelButton
      }
      // load clear list for item (safe if list is empty)
      this.clearList = this.getClearList({
        item: this.item,
        character: this.character,
        adjustments: this.adjustments,
      })
      console.log('SHOW clearList=', this.clearList)

      // If there is nothing actually linked to clear (no container,
      // runes, spells, adjustments, etc.) then skip showing the
      // dialog entirely and immediately resolve as if the user
      // confirmed. This avoids an empty confirmation popup.
      if (!Array.isArray(this.clearList) || this.clearList.length === 0) {
        if (this.forceOpenWhenEmpty) {
          this.clearList = this.emptyListEntry ? [this.emptyListEntry] : []
        } else {
          return Promise.resolve({ cancel: false })
        }
      }

      if (
        this.forceOpenWhenEmpty &&
        Array.isArray(this.clearList) &&
        this.clearList.length === 0
      ) {
        this.clearList = ['No linked values.']
      }

      if (!Array.isArray(this.clearList) || this.clearList.length === 0) {
        return Promise.resolve({ cancel: false })
      }

      this.$refs.popup.open()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    //================================================================================
    // get clear list
    //----------------
    getClearList({ item, character, adjustments }) {
      console.log('getClearList =', item)
      let clearList = []
      const characterRunes = Array.isArray(character?.runes)
        ? character.runes
        : []
      const characterSpells = Array.isArray(character?.spells)
        ? character.spells
        : []
      const itemId = this.normalizeId(item?.id)
      const unavailableSuffix = this.showTransferUnavailableWarnings
        ? ' [will become unavailable/unintegrated]'
        : ''
      const formatAdjValue = (value) => {
        const numericValue = Number(value)

        if (!Number.isFinite(numericValue)) {
          return String(value ?? '').trim()
        }

        if (numericValue > 0) {
          return `+${numericValue}`
        }

        return `${numericValue}`
      }
      const appendWarningSuffix = (label, shouldWarn = false) => {
        if (!shouldWarn || unavailableSuffix === '') {
          return label
        }

        return `${label}${unavailableSuffix}`
      }
      const currentCharacterId = this.normalizeId(character?.id)
      const showRuneStatusSuffixes =
        this.showRecoveryUnavailableWarnings === true ||
        this.showTransferUnavailableWarnings === true
      const transferSenderCharacterId = this.normalizeId(
        character?.sender_character_id ?? character?.sender_character?.id,
      )
      const transferSenderCharacterName = String(
        character?.sender_character_name ??
          character?.sender_character?.name ??
          '',
      ).trim()
      const isRuneAlreadyIntegrated = (rune) => {
        if (!rune) {
          return false
        }

        return rune.already_integrated === true
      }
      const getRecoveryRuneStatusSuffix = (rune) => {
        if (!showRuneStatusSuffixes || !rune) {
          return ''
        }

        const integratedCharacterId = this.normalizeId(
          rune?.integrated_character ??
            rune?.integrated_character_id ??
            rune?.integrated_character?.id,
        )
        const integratedCharacterName = String(
          rune?.integrated_character_name ??
            rune?.integrated_character?.name ??
            '',
        ).trim()

        if (
          rune.integrated == true &&
          isRuneAlreadyIntegrated(rune) &&
          currentCharacterId !== null &&
          integratedCharacterId === currentCharacterId
        ) {
          return ' [Recovering Own Rune]'
        }

        if (isRuneAlreadyIntegrated(rune) && integratedCharacterName !== '') {
          return ` [Unavailable - Integrated with ${integratedCharacterName}]`
        }

        if (rune.integrated == false && isRuneAlreadyIntegrated(rune)) {
          return ' [Unavailable - Integrated with Unknown Individual]'
        }

        if (rune.integrated == false && !isRuneAlreadyIntegrated(rune)) {
          return ' [Available for Integration]'
        }

        return ''
      }
      const isRecoveryRuneUnavailable = (rune) => {
        return !!rune && isRuneAlreadyIntegrated(rune)
      }
      const getRecoveryRuneSpellStatusSuffix = (rune) => {
        if (!showRuneStatusSuffixes || !rune) {
          return ''
        }

        const integratedCharacterId = this.normalizeId(
          rune?.integrated_character ??
            rune?.integrated_character_id ??
            rune?.integrated_character?.id,
        )

        if (
          rune.integrated == true &&
          isRuneAlreadyIntegrated(rune) &&
          currentCharacterId !== null &&
          integratedCharacterId === currentCharacterId
        ) {
          return ''
        }

        if (isRecoveryRuneUnavailable(rune)) {
          return ' [Inactive]'
        }

        if (rune.integrated == false && !isRuneAlreadyIntegrated(rune)) {
          return ' [Available when Rune Integrated]'
        }

        return ''
      }
      const getIntegratedRuneImplicitAdjustmentKey = (rune) => {
        if (!rune) {
          return ''
        }

        const runeRef = this.normalizeId(
          rune?.rune_id ?? rune?.rune?.id ?? rune?.rune,
        )

        if (runeRef !== null) {
          return `id:${runeRef}`
        }

        return String(rune?.name ?? rune?.display_name ?? '')
          .trim()
          .replace(/\s+\d+\b$/, '')
          .toLowerCase()
      }
      const getExternalIntegratedRuneImplicitAdjustmentKeys = () => {
        return new Set(
          characterRunes
            .filter((rune) => {
              if (!rune || rune?.integrated !== true) {
                return false
              }

              return this.getLinkedCharacterItemId(rune) !== itemId
            })
            .map((rune) => getIntegratedRuneImplicitAdjustmentKey(rune))
            .filter((key) => key !== ''),
        )
      }
      const externalIntegratedRuneImplicitAdjustmentKeys =
        getExternalIntegratedRuneImplicitAdjustmentKeys()
      const getTransferPreviewRuneState = (rune) => {
        if (!this.showTransferUnavailableWarnings || !rune) {
          return rune
        }

        if (rune.integrated == true && !isRuneAlreadyIntegrated(rune)) {
          return {
            ...rune,
            already_integrated: true,
            integrated_character:
              rune?.integrated_character ??
              rune?.integrated_character_id ??
              transferSenderCharacterId,
            integrated_character_name:
              rune?.integrated_character_name ??
              rune?.integrated_character?.name ??
              transferSenderCharacterName,
          }
        }

        return rune
      }

      if (!item) {
        return []
      }

      const itemPowerStorage = Number(item?.pwr_storage ?? 0)
      if (Number.isFinite(itemPowerStorage) && itemPowerStorage > 0) {
        clearList.push(
          `Power Storage (${this.formatPowerStorageValue(itemPowerStorage)})`,
        )
      }

      const itemTraits = Array.isArray(item?.item_traits)
        ? item.item_traits
        : []
      itemTraits.forEach((trait) => {
        const traitLabel = String(
          trait?.name ?? trait?.description ?? '',
        ).trim()

        if (traitLabel !== '') {
          clearList.push(`Item Trait: ${traitLabel}`)
        }
      })

      console.log('item.container = ', item.container)
      // Note: we no longer show any container relationship here; when
      // an item is cleared or deleted, the container itself remains
      // and only the stored-in link is nulled silently.
      //----------------------------
      // worn_location
      //----------------------------
      // Character worn locations themselves are fixed as part of the
      // character; deleting an item only nulls the FK. We therefore do
      // not show a separate clearList entry for worn_location.
      const linkedCharacterRunes = characterRunes.filter((r) => {
        return this.getLinkedCharacterItemId(r) === itemId
      })
      const previewItemRunes = Array.isArray(item?.runes) ? item.runes : []
      const linkedRunes =
        linkedCharacterRunes.length > 0
          ? linkedCharacterRunes
          : previewItemRunes
      const linkedRunesForDisplay = (() => {
        const seen = new Set()

        return linkedRunes
          .map((rune) => getTransferPreviewRuneState(rune))
          .filter((rune) => {
            if (!rune) {
              return false
            }

            const dedupeKey = [
              this.normalizeId(rune?.id) ?? '',
              String(rune?.name ?? '').trim(),
              String(rune?.display_name ?? '').trim(),
              rune?.strength ?? '',
              rune?.integrated ?? '',
            ].join('|')

            if (seen.has(dedupeKey)) {
              return false
            }

            seen.add(dedupeKey)
            return true
          })
      })()
      const allRunes =
        characterRunes.length > 0 ? characterRunes : previewItemRunes
      const previewRuneSpells = previewItemRunes.flatMap((rune) => {
        const runeName = String(rune?.name || '').trim()
        const runeSpells = Array.isArray(rune?.spells) ? rune.spells : []

        return runeSpells.map((spell) => ({
          ...spell,
          source: spell?.source ?? 'rune',
          character_rune: spell?.character_rune ?? rune?.id ?? null,
          casting_rune_name: spell?.casting_rune_name ?? runeName,
        }))
      })
      const previewItemSpells = Array.isArray(item?.non_rune_spells)
        ? item.non_rune_spells.map((spell) => ({
            ...spell,
            character_item:
              spell?.character_item ??
              spell?.character_item_id ??
              item?.id ??
              null,
          }))
        : Array.isArray(item?.spells)
          ? item.spells.filter((spell) => {
              const sourceLabel = (spell?.source || '').toString().toLowerCase()

              return !(
                sourceLabel === 'rune' ||
                spell?.character_rune != null ||
                spell?.character_rune_id != null
              )
            })
          : []
      const linkedCharacterRuneIds = new Set(
        linkedCharacterRunes
          .map((rune) => this.normalizeId(rune?.id))
          .filter((id) => id !== null),
      )
      const hasLiveLinkedSpells = characterSpells.some((spell) => {
        const linkedCharacterItemId = this.getLinkedCharacterItemId(spell)
        const linkedRuneId = this.normalizeId(
          spell?.character_rune ?? spell?.character_rune_id ?? spell?.source_id,
        )

        return (
          linkedCharacterItemId === itemId ||
          (linkedRuneId !== null && linkedCharacterRuneIds.has(linkedRuneId))
        )
      })
      const allSpells =
        linkedCharacterRunes.length > 0 || hasLiveLinkedSpells
          ? characterSpells
          : [...previewRuneSpells, ...previewItemSpells]
      //---------------------------------------------------
      // add entry if integrated runes (could be multiple)
      //---------------------------------------------------
      const item_runes_integrated = linkedRunesForDisplay.filter((r) => {
        return r && r.integrated == true
      })
      if (item_runes_integrated.length > 0) {
        const seenIntegratedRuneLabels = new Set()
        const seenRuneTraitLabels = new Set()
        const seenIntegratedRuneImplicitAdjustmentKeys = new Set()

        item_runes_integrated.forEach((rune) => {
          const recoveryRuneStatusSuffix = getRecoveryRuneStatusSuffix(rune)
          const transferRuneLinkedValueSuffix =
            getRecoveryRuneSpellStatusSuffix(rune)
          const implicitAdjustmentKey =
            getIntegratedRuneImplicitAdjustmentKey(rune)
          const isCoveredByExternalIntegratedRune =
            implicitAdjustmentKey !== '' &&
            externalIntegratedRuneImplicitAdjustmentKeys.has(
              implicitAdjustmentKey,
            )
          const shouldIncludeImplicitRuneAdjustments =
            !isCoveredByExternalIntegratedRune &&
            (implicitAdjustmentKey === '' ||
              !seenIntegratedRuneImplicitAdjustmentKeys.has(
                implicitAdjustmentKey,
              ))
          const integratedRuneLabel = `Integrated Rune: ${rune.name} Strength (${rune.strength})${recoveryRuneStatusSuffix}`

          if (!seenIntegratedRuneLabels.has(integratedRuneLabel)) {
            seenIntegratedRuneLabels.add(integratedRuneLabel)
            clearList.push(integratedRuneLabel)
          }

          const traitName = String(rune?.trait_name ?? rune?.trait ?? '').trim()

          if (traitName !== '' && shouldIncludeImplicitRuneAdjustments) {
            const runeTraitLabel = `Rune Trait: ${traitName}${transferRuneLinkedValueSuffix}`

            if (!seenRuneTraitLabels.has(runeTraitLabel)) {
              seenRuneTraitLabels.add(runeTraitLabel)
              clearList.push(runeTraitLabel)
            }
          }

          if (
            this.showTransferUnavailableWarnings ||
            this.showRecoveryUnavailableWarnings
          ) {
            if (
              shouldIncludeImplicitRuneAdjustments &&
              implicitAdjustmentKey !== ''
            ) {
              seenIntegratedRuneImplicitAdjustmentKeys.add(
                implicitAdjustmentKey,
              )
            }

            if (!shouldIncludeImplicitRuneAdjustments) {
              return
            }

            const characteristicAdjustments = Array.isArray(
              rune?.characteristic_adjustments,
            )
              ? rune.characteristic_adjustments
              : []
            characteristicAdjustments.forEach((adj) => {
              const name = String(adj?.name || '').trim()
              const value = formatAdjValue(adj?.adj_value)

              if (name !== '' && value !== '') {
                clearList.push(
                  `Rune Characteristic Adjs: ${name} (${value})${transferRuneLinkedValueSuffix}`,
                )
              }
            })

            const characteristicSkillAdjustments = Array.isArray(
              rune?.characteristic_skill_adjustments,
            )
              ? rune.characteristic_skill_adjustments
              : []
            characteristicSkillAdjustments.forEach((adj) => {
              const name = String(adj?.name || '').trim()
              const value = formatAdjValue(adj?.adj_value)

              if (name !== '' && value !== '') {
                clearList.push(
                  `Rune Characteristic Skill Adjs: ${name} (${value})${transferRuneLinkedValueSuffix}`,
                )
              }
            })

            const abilityAdjustments = Array.isArray(rune?.ability_adjustments)
              ? rune.ability_adjustments
              : []
            abilityAdjustments.forEach((adj) => {
              const name = String(adj?.name || '').trim()
              const value = formatAdjValue(adj?.adj_value)

              if (name !== '' && value !== '') {
                clearList.push(
                  `Rune Ability Adjs: ${name} (${value})${transferRuneLinkedValueSuffix}`,
                )
              }
            })

            const skillAdjustments = Array.isArray(rune?.skill_adjustments)
              ? rune.skill_adjustments
              : []
            skillAdjustments.forEach((adj) => {
              const name = String(adj?.name || '').trim()
              const value = formatAdjValue(adj?.adj_value)
              const prefix =
                adj?.applied === false
                  ? 'Rune Skill (Optional) Adjs'
                  : 'Rune Skill (Applied) Adjs'

              if (name !== '' && value !== '') {
                clearList.push(
                  `${prefix}: ${name} (${value})${transferRuneLinkedValueSuffix}`,
                )
              }
            })
          }
        })
      }
      //-----------------------------------------------------
      // add entry if unintegrated runes (could be multiple)
      //-----------------------------------------------------
      const item_runes_unintegrated = linkedRunesForDisplay.filter((r) => {
        return r && r.integrated == false
      })
      if (item_runes_unintegrated.length > 0) {
        const seenUnintegratedRuneLabels = new Set()

        item_runes_unintegrated.forEach((rune) => {
          const recoveryRuneStatusSuffix = getRecoveryRuneStatusSuffix(rune)
          const label = `Unintegrated Rune: ${rune.name} Strength (${rune.strength})${recoveryRuneStatusSuffix}`

          if (seenUnintegratedRuneLabels.has(label)) {
            return
          }

          seenUnintegratedRuneLabels.add(label)
          clearList.push(label)
        })
      }
      //----------------------------------------------------------------
      // add entries for rune-linked spells that will be removed because
      // deleting this item removes the last rune(s) of a given name
      //----------------------------------------------------------------
      if (linkedRunes.length > 0 && allSpells.length > 0) {
        const integratedRuneIds = new Set(
          item_runes_integrated.map((rune) => this.normalizeId(rune.id)),
        )
        const integratedRuneNames = new Set(
          item_runes_integrated
            .map((rune) => String(rune?.name || '').trim())
            .filter((name) => name !== ''),
        )
        const deletedRuneNames = [
          ...new Set(
            linkedRunes
              .map((r) => (r?.name || '').toString().trim())
              .filter((name) => name !== '')
              .filter((name) => {
                return !allRunes.some(
                  (candidate) =>
                    linkedRunes !== previewItemRunes &&
                    this.getLinkedCharacterItemId(candidate) !== itemId &&
                    (candidate?.name || '').toString().trim() === name,
                )
              }),
          ),
        ]

        if (deletedRuneNames.length > 0) {
          const runeSpellKeys = new Set()
          const linkedRuneSpells = allSpells.filter((spell) => {
            if (!spell) return false

            const sourceLabel = (spell.source || '').toString().toLowerCase()
            const spellRuneName = (spell.casting_rune_name || '')
              .toString()
              .trim()
            const spellRuneId = this.normalizeId(
              spell.character_rune ??
                spell.character_rune_id ??
                spell.source_id,
            )

            const matchesDeletedRuneName =
              spellRuneName !== '' && deletedRuneNames.includes(spellRuneName)
            const matchesDeletedRuneId = linkedRunes.some(
              (rune) => this.normalizeId(rune.id) === spellRuneId,
            )

            if (
              !(
                (sourceLabel === 'rune' || spell.character_rune != null) &&
                (matchesDeletedRuneName || matchesDeletedRuneId)
              )
            ) {
              return false
            }

            const dedupeKey = [
              this.normalizeId(
                spell.character_spell_id ??
                  spell.character_rune_spell_id ??
                  spell.character_item_spell_id ??
                  spell.id,
              ) || spell.name,
              spell.mag ?? '',
            ].join('|')

            if (runeSpellKeys.has(dedupeKey)) {
              return false
            }

            runeSpellKeys.add(dedupeKey)
            return true
          })

          linkedRuneSpells.forEach((spell) => {
            const spellRuneId = this.normalizeId(
              spell.character_rune ??
                spell.character_rune_id ??
                spell.source_id,
            )
            const spellRuneName = String(spell?.casting_rune_name || '').trim()
            const linkedPreviewRune = linkedRunesForDisplay.find((rune) => {
              const runeId = this.normalizeId(rune?.id)
              const runeName = String(rune?.name || '').trim()

              return (
                (spellRuneId !== null && runeId === spellRuneId) ||
                (spellRuneName !== '' && runeName === spellRuneName)
              )
            })
            const shouldWarn =
              this.showTransferUnavailableWarnings &&
              ((spellRuneId !== null && integratedRuneIds.has(spellRuneId)) ||
                (spellRuneName !== '' &&
                  integratedRuneNames.has(spellRuneName)))
            const recoverySpellStatusSuffix =
              getRecoveryRuneSpellStatusSuffix(linkedPreviewRune)

            clearList.push(
              `Rune Spell: ${this.formatSpellLabel(spell)}${recoverySpellStatusSuffix}`,
            )
          })
        }
      }
      //---------------------------------------------
      // add entry for any item-granted spells
      //---------------------------------------------
      if (allSpells.length > 0 && item.id !== undefined && item.id !== null) {
        const item_spells = allSpells.filter((s) => {
          if (this.getLinkedCharacterItemId(s) !== itemId) {
            return false
          }

          const sourceLabel = (s?.source || '').toString().toLowerCase()
          const isRuneLinkedSpell =
            sourceLabel === 'rune' ||
            s?.character_rune != null ||
            s?.character_rune_id != null

          return !isRuneLinkedSpell
        })
        if (item_spells.length > 0) {
          item_spells.forEach((spell) => {
            clearList.push(
              `${this.formatItemSpellPrefix(spell)}: ${this.formatSpellLabel(spell)}`,
            )
          })
        }
      }
      //----------------------------------
      // add entry if characteristic adjs
      //----------------------------------
      if (adjustments.item_characteristic_adj_reasons !== '') {
        this.appendReasonEntries(
          clearList,
          'Characteristic Adjs',
          adjustments.item_characteristic_adj_reasons,
        )
      }
      //---------------------------
      // add entry if ability adjs
      //---------------------------
      if (adjustments.item_ability_adj_reasons !== '') {
        this.appendReasonEntries(
          clearList,
          'Ability Adjs',
          adjustments.item_ability_adj_reasons,
        )
      }
      if (adjustments.item_characteristic_skill_adj_reasons !== '') {
        this.appendReasonEntries(
          clearList,
          'Characteristic Skill Adjs',
          adjustments.item_characteristic_skill_adj_reasons,
        )
      }
      //-----------------------------------
      // add entry if skill (applied) adjs
      //-----------------------------------
      if (adjustments.item_skill_adj_reasons_applied !== '') {
        this.appendReasonEntries(
          clearList,
          'Skill (Applied) Adjs',
          adjustments.item_skill_adj_reasons_applied,
        )
      }
      //------------------------------------
      // add entry if skill (optional) adjs
      //------------------------------------
      if (adjustments.item_skill_adj_reasons_optional !== '') {
        this.appendReasonEntries(
          clearList,
          'Skill (Optional) Adjs',
          adjustments.item_skill_adj_reasons_optional,
        )
      }
      return clearList
    },
    //================================================================================
    // cancel
    //--------
    _cancel() {
      const popup = this.$refs.popup
      if (popup && typeof popup.close === 'function') {
        popup.close()
      }
      if (this.resolvePromise) {
        this.resolvePromise({ cancel: true })
      }
    },
    //================================================================================
    // confirm
    //---------
    _confirm() {
      const popup = this.$refs.popup
      if (popup && typeof popup.close === 'function') {
        popup.close()
      }
      if (this.resolvePromise) {
        this.resolvePromise({ cancel: false })
      }
    },
  },
  //=====================================================================
  // computed
  //----------
  computed: {},
}
</script>

<style scoped>
.bb-clear-dialog-content {
  box-sizing: border-box;
  padding-bottom: 1.75rem;
}

.clear-dialog-list-row {
  margin-bottom: 1.75rem !important;
}

.clear-dialog-list-group,
.clear-dialog-list-floating {
  min-height: auto;
}

/* scrollable list styled like a v-select dropdown menu inside a floating field */
.form-floating > .form-control.clearList-dialog-select {
  height: 22rem;
  /* override default form-floating height */
  min-height: 22rem;
  max-height: 22rem;
  width: 100%;
  max-width: 100%;
  /* mimic .v-select .vs__dropdown-menu styling */
  margin-top: 10px;
  box-shadow: 0px 0px 1px 1px #737373;
  border-radius: 5px;
  padding-bottom: 1.5rem;
  text-transform: capitalize;
  overflow-x: auto;
  overflow-y: auto;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  box-sizing: border-box;
}

.clear-dialog-list-row,
.clear-dialog-list-group,
.clearList-dialog-select,
.clearList-item {
  min-width: 0;
}

.clearList-item {
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.clearList-item + .clearList-item {
  padding-top: 0.8rem;
}

/* reduce counter label font-size only inside this dialog */
::v-deep(.text-center.col-auto .bb-float-label) {
  font-size: 0.8em;
}
</style>
